import toast from 'shared/utils/toast';
import { useTranslation } from 'react-i18next';
import { productWarehouseCostApi } from './api/productWarehouseCostApi';
import { useProductWarehouseCostLinkOptions } from './hooks';
import { ProductWarehouseLinkMode } from './types';
import {
  EnhancedDialog,
  EnhancedForm,
  IdentityField,
  AutocompleteAdapter
} from 'components/enhanced';

export default function ProductWarehouseToCostDialog(props: {
  productWarehouseId: number;
  mode: ProductWarehouseLinkMode;
  setMode: (mode: ProductWarehouseLinkMode) => void;
  callback?: () => void;
}) {
  const { t } = useTranslation();

  const { productWarehouseId, mode, setMode, callback } = props;
  const { options } = useProductWarehouseCostLinkOptions(mode);

  const handleClose = () => {
    setMode('');
  };

  const onSubmit = (values: { object_id: number }) => {
    productWarehouseCostApi.addCostLink(productWarehouseId, mode, values.object_id).then(() => {
      toast.success(t('actions.successfully.cost-associated'));
      handleClose();
      if (callback) callback();
    });
  };

  return (
    <EnhancedDialog
      open={mode.length > 0}
      onClose={handleClose}
      title={t('global.add-cost-source')}
      submitLabel={t('actions.save', 'Salva')}
      cancelLabel={t('actions.reset', 'Annulla')}
      maxWidth="sm"
      submitButtonProps={{
        type: 'submit',
        form: 'addPWCostLink'
      }}>
      <EnhancedForm onSubmit={onSubmit} formId="addPWCostLink" hideControls>
        <div className="w-full my-4">
          {options && (
            <IdentityField
              name="object_id"
              component={AutocompleteAdapter}
              options={options}
              label={t('global.cost-source')}
              disablePortal
            />
          )}
        </div>
      </EnhancedForm>
    </EnhancedDialog>
  );
}
